/*--------------------------------------------------------------------------------------------
Program     :  Dashboard.js
Description :  Main program for Map and Track Dashboard
Date        :  29/08/2024 
Created By  :  Fode/Jelbin
---------------------------------------------------------------------------------------------
TicketNo        Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
29082024       -Fode/Jelbin     -  29/08/2024        Created
---------------------------------------------------------------------------------------------*/
import React, { useState, useEffect } from "react";
import { ThemeProvider, Box, CssBaseline, AppBar, Toolbar, Typography } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Mapandtrack from "./Mapandtrack";
import AvatarMenu from "./AvatarMenu";
import AuthService from "../service/AuthService";
import { useNavigate } from 'react-router-dom';
import psLogo from "../pictures/map2.png";
import MainService from "../service/MainService";
import { useMapTrackInfo } from "../context/Maptrackcontext";
import { jwtDecode } from "jwt-decode";

const mdTheme = createTheme();
const Dashboard = () => {
  const [open, setOpen] = useState(true); // Drawer state
  const [user, setUser] = useState(AuthService.getCurrentUser());
  const { envFileData, setEnvFileData,setUserReadOnly} = useMapTrackInfo();

  const navigate = useNavigate();
  setUserReadOnly(localStorage.getItem("UserviewMode"));

  // Get Company data from env file during page load
  useEffect(() => {
    MainService.getCompanyData()
      .then((response) => {
        const decryptResponse = response.data.envinfo;
        const decodedCompanyData = jwtDecode(decryptResponse);
        setEnvFileData(decodedCompanyData);
      })
      .catch((err) => console.error("Error fetching company Data:", err));
  }, []);

  // UseEffect to disable the back navigation
  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      // navigate('/Dashboard', { replace: true });
    };

    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{
        display: 'flex',
        padding: '0px',
        height: '100vh',        // Make the box take full viewport height
        overflow: 'hidden',     // Prevent scrolling of the entire dashboard
        width: '100vw'          // Make the box take full viewport width
      }}>
        <CssBaseline />

        {/* AppBar Component */}
        <AppBar position="absolute" open={open}>

          <Toolbar sx={{
            pr: '24px', backgroundColor: '#1976D2'
          }}>
            {/* Title */}
            <Typography component="h1" variant="h6" color="white" noWrap sx={{ ml: 1, flexGrow: 1 }}>
              <b>Mapandtrack</b>
            </Typography>

            {/* Avatar Menu */}
            {user ? <AvatarMenu user={user} /> : null}
          </Toolbar>
        </AppBar>

        {/* Main Content */}
        <Box component="main" sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 64px)', // Subtract AppBar height (usually 64px)
          mt: 8,                  // Adjust to prevent overlap with AppBar
          padding: 0,             // Remove all padding
          overflow: 'hidden',     // Prevent scrolling
        }}>
          {envFileData ?
            <Mapandtrack/> : <></>}
        </Box>

      </Box>
    </ThemeProvider>
  );
};

export default Dashboard;
